export class EncodeJsonBase64 {
  public static encodeObjectToBase64(obj: object) {
    const jsonString = JSON.stringify(obj);
    const utf8Bytes = new TextEncoder().encode(jsonString);

    function uint8ToBinaryString(uint8) {
      const CHUNK_SIZE = 0x8000;
      let result = '';
      for (let i = 0; i < uint8.length; i += CHUNK_SIZE) {
        result += String.fromCharCode.apply(null, uint8.subarray(i, i + CHUNK_SIZE));
      }
      return result;
    }

    const binary = uint8ToBinaryString(utf8Bytes);
    return btoa(binary);
  }

  public static decodeBase64ToObject(base64) {
    try {
      // Step 1: Decode base64 to binary string
      let binary;
      try {
        binary = atob(base64);
      } catch (e) {
        throw new Error('Invalid base64 string.');
      }

      // Step 2: Convert binary string to Uint8Array
      let bytes;
      try {
        bytes = new Uint8Array([...binary].map((c) => c.charCodeAt(0)));
      } catch (e) {
        throw new Error('Failed to convert base64 to byte array.');
      }

      // Step 3: Decode UTF-8 bytes to string
      let jsonString;
      try {
        jsonString = new TextDecoder().decode(bytes);
      } catch (e) {
        throw new Error('Failed to decode UTF-8 bytes.');
      }

      // Step 4: Parse JSON
      let obj;
      try {
        obj = JSON.parse(jsonString);
      } catch (e) {
        throw new Error('Failed to parse JSON string.');
      }

      return obj;
    } catch (err) {
      return null;
    }
  }
}
